import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import Header from "../../components/header";
import blogheaderimage from "../../assets/image/blog.webp";
import { getBlogById } from "../../api/api";
import AOS from "aos";
import "aos/dist/aos.css";
import dayjs from "dayjs";
import { useNavigate } from "react-router-dom";
import "./blogdetail.css";
import { Row, Col } from "react-bootstrap";
import SpinLoading from "../../components/spinLoading/SpinLoading";
import { handleError } from "../../helpers/handleError";
import DOMPurify from "dompurify";
const BlogDetail = () => {
  const { id } = useParams();
  const [blog, setBlog] = useState({});
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false)
  const [nav, setNav] = useState([
    {
      title: "Inicio",
      path: "/event",
    },
    {
      title: "Blog",
      path: "/blog",
    },
  ]);

  const fetchBlog = async () => {
    try {
      setIsLoading(true)
      const response = await getBlogById(id);
      if (response.status === 200) {
        setBlog(response.data.info);
        setNav((prev) => [...prev, { title: response.data.info.title, path: `/blog/${response.data.info._id}` }]);
      }
    } catch (error) {
      handleError(error);
      navigate(-1);
    } finally {
      setIsLoading(false)
    }
  };

  useEffect(() => {
    AOS.init({
      disable: function () {
        return window.innerWidth < 425;
      },
    });
    if (id) {
      fetchBlog();
      window.scrollTo(0, 0);
    } else {
      navigate(-1);
    }
  }, [id]);
  if (isLoading) return <SpinLoading />
  return (
    <>
      <Header imageSrc={blogheaderimage} title="Blog" navigation={nav} />
      <div className="pading150 blogdetail">
        <div className="blogdetailimage">
          <img className="blogdetailimage1" src={blog.image} alt={blog.title} />
        </div>
        <div className="blogdetailinfo">
          <div className="blogdetaildate">{dayjs(blog.createdAt).format("D [de] MMMM [de] YYYY")}</div>
          <div className="blogdetailtitle">{blog.title}</div>
          <div className="blogdetaildescription">{blog.description}</div>
        </div>
        {blog.content && (
          <div className="blogdetailcontent">
            <div dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(blog.content) }} />
          </div>
        )}
        {blog.image2 && blog.image2.length > 0 && (
          <Row className="blogdetailimage2">
            {blog.image2.map((image, index) => (
              <Col xs={12} sm={6} md={4} key={index} data-aos="fade-up">
                <img className="blogdetailimage21" src={image} alt={blog.title} />
              </Col>
            ))}
          </Row>
        )}
        {blog.content2 && <div className="blogdetailcontent2" dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(blog.content2) }} />}
      </div>
    </>
  );
};

export default BlogDetail;
